import { useCallback, useState } from "react";


/**
 *  Provides a basic hook for tacking state of a boolean.
 * 
 * @example
 * // Since this hook returns an array, the first and second item can be aliased to whatever name
 * // you'd like.
 * const [on, toggle] = useToggle(true);
 * <button onClick={toggle}>Toggle</button>
 * <button onClick={() => toggle(true)}>Toggle TRUE</button>
 * <button onClick={() => toggle(false)}>Toggle FALSE</button>
 * @param {boolean} initialState The initial state value to be set.
 * @returns An array, where the first element is the state of the toggle and the second item is the toggle function.
 */
export const useToggle = (initialState) => {
    const [isOpen, setIsOpen] = useState(initialState);

    return [isOpen, useCallback(() => setIsOpen(x => !x))];
};